import { useUserReviewsInitialData } from '@/scopes/products/user-reviews/hooks';
import { Button, Typography, tk, horizontalGap, Skeleton } from '@sunwebgroup/ui-components';
import { useIntl } from 'react-intl';
import { styled } from 'styled-components';

const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  ${horizontalGap('spacing_lg')}
`;

const DisclamerButton = styled.div`
  align-items: center;
  padding: ${tk('spacing_md')} 0;

  &:hover {
    ${Typography} {
      text-decoration: underline;
      cursor: pointer;
    }
  }
  ${Typography} {
    color: ${tk('color_semantic_text_strong')};
  }
`;

const DisclamerButtonSkeleton = styled(Skeleton)`
  height: ${tk('spacing_lg')};
  width: 200px;
`;

const ExtendButtonSkeleton = styled(Skeleton)`
  height: ${tk('spacing_lg')};
  width: 300px;
  margin-top: ${tk('spacing_md')};
  margin-bottom: ${tk('spacing_md')};
`;

interface ActionButtonsProps {
  openExtendedModal: () => void;
  openLegalDisclamerModal: () => void;
}

export function ActionButtons({ openExtendedModal, openLegalDisclamerModal }: ActionButtonsProps) {
  const { reviewsAmount, isFetched, isLoading } = useUserReviewsInitialData();
  const intl = useIntl();

  if (isLoading)
    return (
      <ButtonsWrapper>
        <ExtendButtonSkeleton />
        <DisclamerButtonSkeleton />
      </ButtonsWrapper>
    );

  if (isFetched && !reviewsAmount) return null;

  return (
    <ButtonsWrapper>
      <Button $hierarchy="secondary" onClick={openExtendedModal}>
        {intl.formatMessage({ id: 'reviews_teaser_see_all_reviews' }, { amount: reviewsAmount })}
      </Button>
      <DisclamerButton onClick={openLegalDisclamerModal}>
        <Typography $variant="body-sm">{intl.formatMessage({ id: 'reviews_teaser_legal_disclaimer' })}</Typography>
      </DisclamerButton>
    </ButtonsWrapper>
  );
}
